// import tweetme from '../../assets/projects_images/tweetme.PNG'
// import chatapp from '../../assets/projects_images/chatapp.JPG'
// import hardware_store from '../../assets/projects_images/hardware_store.jpg'
// import portfolio from '../../assets/projects_images/portfolio.JPG'
// import new_year from '../../assets/projects_images/new_year.jpg'
// import color_classification from '../../assets/projects_images/color_classification.jpg'
// import blinking from '../../assets/projects_images/blinking.JPG'
// import Dev_talks from '../../assets/projects_images/Dev_talks.jpg'
import youtubeclone from '../../assets/projects_images/youtubeclone.png'
import Textutils from '../../assets/projects_images/textutils.png'
import covid19 from '../../assets/projects_images/covid19.png'
import pagination from '../../assets/projects_images/pagination.png'
import calculator from '../../assets/projects_images/calculator.png'
import readmegenrate from '../../assets/projects_images/readmegenrate.png'
import blog from '../../assets/projects_images/blog.png'
import lovestruck from '../../assets/projects_images/love-struck.png'




const data_projects = [
    {
        name: 'Textutils',
        image: Textutils,
        deployed_url: 'https://textutils-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/Youtube-clone-ReactJS',
        category: ['react.js']
    },
    {
        name: 'Calculator',
        image: calculator,
        deployed_url: 'https://calculator-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['react.js']
    },
    {
        name: 'Pagination',
        image: pagination,
        deployed_url: 'https://pagination-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['react.js']
    },
    {
        name: 'Blog',
        image: blog,
        deployed_url: 'https://blog-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['react.js']
    },
    {
        name: 'Readme Genrator',
        image: readmegenrate,
        deployed_url: 'https://github-readme-genrator.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['html_css', 'HTML', 'react.js']
    },
    {
        name: 'Covid19 Tracker',
        image: covid19,
        deployed_url: 'https://corona-react-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['react.js']
    },
    {
        name: 'Youtube Clone',
        image: youtubeclone,
        deployed_url: 'https://youtube-pankaj.netlify.app/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['node.js', 'react.js']
    },
    {
        name: 'Love struck',
        image: lovestruck,
        deployed_url: 'https://love-struck.com/',
        github_url: 'https://github.com/pankajkanani/',
        category: ['wordpress']
    }
]

export default data_projects;